import { DataTableProvider } from 'components/DataTable'
import { ColumnsStoreProvider } from 'stores/ColumnsStore/ColumnsStoreProvider'
import {
  VariantSearchTableInner,
  type VariantSearchTableInnerProps,
} from './VariantSearchTableInner'

export interface VariantSearchTableProps extends VariantSearchTableInnerProps {}

/**
 * Reusable VariantSearchTable component with isolated state.
 *
 * Supports two modes:
 * 1. **standalone**: Used in the main variants view for browsing/exporting variants
 * 2. **selection**: Used in product edit modal for selecting variants to match
 *
 * Both modes support row selection. The difference is in how selection is used:
 * - standalone: For bulk export and bulk matching
 * - selection: For bulk matching to product
 */
export function VariantSearchTable(props: VariantSearchTableProps) {
  // Show actions column only in standalone mode
  const defaultColumnVisibility =
    props.mode === 'standalone' ? { edit: true } : { edit: false }

  // Add version suffix to tableKey to reset localStorage when columns change
  const tableKey = `${props.tableKey}-v3`

  return (
    <ColumnsStoreProvider
      tableKey={tableKey}
      defaultColumnVisibility={defaultColumnVisibility}
    >
      <DataTableProvider tableKey={tableKey}>
        <VariantSearchTableInner {...props} tableKey={tableKey} />
      </DataTableProvider>
    </ColumnsStoreProvider>
  )
}
